'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import TextInput from 'Components/Forms/Elements/TextInput';
import EtablishmentRow from 'Components/Lists/Rows/Etablishment';
import Dashboard from 'Components/Lists/Dashboard';
import DefaultModal from 'Modals/DefaultModal';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
const {
  app
} = window;
const header = [{
  name: 'images',
  label: '',
  sortable: false
}, {
  name: 'id_property',
  label: 'Id property'
}, {
  name: 'name',
  label: 'Nom myWO'
}, {
  name: 'address.hotel_name',
  label: 'Nom de l\'hôtel'
}, {
  name: 'email',
  label: 'Email'
}, {
  name: 'phone_number',
  label: 'Téléphone',
  sortable: false
}, {
  name: 'status',
  label: 'Statut'
}, {
  name: 'qr_code',
  label: 'QrCode',
  sortable: false
}, {
  name: 'actions',
  label: '',
  sortable: false
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class EtablishmentsDashboardPage extends Component {
  state = {
    openModal: false,
    loading: false,
    statusMessageClass: ""
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent on mount trigger
    if (!e && fields_without_timeout.includes(name) === false) return;
    component.setState({
      [name]: value
    });
    if (fields_without_timeout.includes(name)) return;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    }, 320);
  };
  onModalClose = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openModal: false
    });
  };
  generateImagesArchive = async () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    try {
      var response = await ajaxRequest(action('getImagesArchive'));
    } catch (error) {
      return component.setState(error);
    }
    component.setState({
      loading: false,
      info: response.info
    });
    setTimeout(function () {
      component.setState({
        openModal: false
      });
    }, 2000);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    let filters = {
      searched: state.delayed_searched
    };
    const can__export = isTrue(app.state.session?.user?.can_export_data);
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Etablissements"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, isTrue(can__export) ? /*#__PURE__*/React.createElement("div", {
      className: "dashboard-right"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: () => component.setState({
        openModal: true
      })
    }, "Export donn\xE9es")) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-right"
    }, /*#__PURE__*/React.createElement(Button, {
      href: URL('NewEtablishment'),
      className: bemit('c-flat-btn', ['primary']),
      component: Link
    }, "Cr\xE9er un \xE9tablissement")), /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleSearchChange,
      placeholder: " Recherche (nom ou ID property)",
      value: state['searched'],
      name: "searched",
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "Etablishment",
      url: action('getAllEtablishments'),
      header: header,
      fields: fields,
      component: EtablishmentRow,
      "items-per-page": 30,
      filters: filters
    })))), /*#__PURE__*/React.createElement(DefaultModal, {
      title: "Exporter donn\xE9es \xE9tablissements",
      open: state.openModal,
      onClose: component.onModalClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-flex-column"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "G\xE9n\xE9rer une archive ZIP contenant toutes les photos des \xE9tablissements et leurs espaces :"), /*#__PURE__*/React.createElement("p", null, "Un email avec un lien de t\xE9l\xE9chargement vous sera envoy\xE9."), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.generateImagesArchive
    }, "G\xE9n\xE9rer l'archive")), /*#__PURE__*/React.createElement("div", {
      className: "u-margin-top-50"
    }, /*#__PURE__*/React.createElement("h3", null, "G\xE9n\xE9rer un ficher CSV contenant toutes les infos des \xE9tablissements?"), /*#__PURE__*/React.createElement(Button, {
      href: action('exportHotelDataCSV'),
      className: bemit('c-flat-btn', ['primary']),
      target: "_blank"
    }, "G\xE9n\xE9rer le fichier CSV"))), getFormStatus(state), loader));
    return output;
  }
}
